import PatientOverviewHNProgressWeeklyGoals from 'dashboard/templates/views/Patient/HN/PatientOverviewHNProgressWeeklyGoals';
import RouteRequirements from "../../../../../../../../model/RouteRequirements";

export const routeRequirements = (new RouteRequirements())
    .setEnabledModules(['HEALTHYNUTRITION']);

export default {
    path: 'weekly-goals',
    name: 'PatientOverviewHNProgressWeeklyGoals',
    component: PatientOverviewHNProgressWeeklyGoals,
    props: true,
    meta: {
        // title: 'Patient Record - Healthy Nutrition - Progress - Weekly Goals',
        // title: t => `${t('patient.patientRecord')} - ${t('screens.healthyNutritionSettingsScreen', 'app_mobile')} - ${t('journeyProgress.progress')} - ${t('nutrition.tabs.progressOverTime')}`,
        // title: 'Healthy Nutrition - Status',
        title: t => `${t('screens.healthyNutritionSettingsScreen', 'app_mobile')} - ${t('journeyBehaviourChangeGoals.status')}`,
        routeRequirements
    },
};